import React, { useRef } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../../TemplateComponent';

function CompDetails({
  col,
  i,
  index,
  onChange,
  eleIndex,
  dropLocation,
  dropInLocation,
  changePosition,
  companyData,
  fromForm,
  duplicatingItem,
  editingInput,
  deleteItem,
  elementId,
}) {
  const companyRef = useRef(null);
  const { t } = useTranslation('common');

  const ifNotContainer = (i, index, item) => {
    return item?.col ? changePosition(item, index, i) : dropInLocation(i, index, item, companyData.id);
  };
  const [{ item, handlerId, isOver }, drop] = useDrop({
    accept: ['container', 'item'],
    drop: () => {
      item?.type === 'container' ? dropLocation(index, item) : ifNotContainer(i, index, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOver: monitor.isOver(),
    }),
  });

  const [{ isDragging }, drag] = useDrag({
    type: col?.type,
    item: () => {
      return { col, index, i };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(companyRef));

  return (
    <div ref={companyRef} style={{ opacity }} data-handler-id={handlerId} key={`${col?.label}_${index}_${i}`}>
      {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.FORM_COMPONENT.COMP_DETAILS.DROP_SECTION_HERE')}</div>}
      <ElementTemplate
        {...col}
        keys={col?.key}
        error={col?.hasError}
        requiredField={col?.required}
        disable={!fromForm || ['0', '3'].includes(col.uniqueId)}
        options={col?.options}
        placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
        fromForm={fromForm}
        duplicatingItem={duplicatingItem}
        editingInput={editingInput}
        index={index}
        i={i}
        id={col?.id}
        value={col?.value}
        onChange={onChange}
        elekey={companyData?.key}
        eleIndex={eleIndex}
        deleteItem={deleteItem}
        showDelete={col?.addingNew}
        elementId={elementId}
      />
    </div>
  );
}

export default CompDetails;
